import clsx from 'clsx';
import Header from 'components/header';
import styles from './styles.module.scss';

type MeaningfulHeaderProps = {
  header: string;
  motto: string;
  className?: string;
};

const MeaningfulHeader: React.FC<MeaningfulHeaderProps> = (props) => {
  const { header, motto, className } = props;

  return (
    <div className={clsx(styles.container, className)}>
      <Header text={header} />
      <p className={styles.motto}>{motto}</p>
    </div>
  );
};

export default MeaningfulHeader;
